module.exports = __webpack_public_path__ + "static/media/green-tape-co-name-brand.e89cd7b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/green-tape-co-name-brand.png
// module id = 499
// module chunks = 0